import { render, staticRenderFns } from "./New-role.vue?vue&type=template&id=9232f03c"
import script from "./New-role.vue?vue&type=script&lang=js"
export * from "./New-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports